<template>
  <standard-layout header="Google Drive durchsuchen">
    <template v-slot:main>
      <div class="mb-2 d-flex">
        <input type="text"
               v-model="query"
               class="form-control">
        <button class="btn btn-primary ml-2"
                @click="search">
          Suchen
        </button>
      </div>
      <div class="list-group" v-if="files && files.length > 0">
        <div class="list-group-item"
             v-for="file in files"
             :key="file.id">
          <span class="small text-muted">{{ file.id }}</span><br/>
          {{ file.name }}
        </div>
      </div>
      <div v-else>
        <span class="text-muted">Keine Dateien gefunden.</span>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";

export default {
  components: {StandardLayout},
  data() {
    return {
      files: [],
      query: '',
    }
  },
  methods: {
    search() {
      const params = (this.query && this.query !== '' ? {q: this.query} : {})
      this.$api.get('/documents', {...params})
          .then(res => this.files = res.data)
          .catch(err => this.handleError(err))
    }
  },
  created() {
    this.search()
  }
}
</script>
